import { render } from "./MainLayout.vue?vue&type=template&id=3619fc40"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"
script.render = render

export default script